import { render, staticRenderFns } from "./SalaryRetoucherTable.vue?vue&type=template&id=9b6be8b4&"
import script from "./SalaryRetoucherTable.vue?vue&type=script&lang=js&"
export * from "./SalaryRetoucherTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports